import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarContas(api, parametros) {
    parametros.operacao = 'buscarContas';

    let retorno = {};
    
    await api.santriGET('/rest/conta', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RConta.js